const userProfileModule = () => import(/* webpackChunkName: 'components/userProfile' */'../userProfile/userProfile');
const headerContactModule = () => import(/* webpackChunkName: 'components/headerContact' */'../header/contact/headerContact');
const gmapModule = () => import(/* webpackChunkName: 'components/gmaps' */'../gmaps/gmapController');

export const Header = class {
  trigger = {
    open: '.js-header-open',
    close: '.js-header-close'
  };
  isOpen = false;
  containers = {
    base: '#js-header',
    map: '.js-header-map',
    domain: '.js-header-domain'
  };
  subnav = {
    trigger: {
      open: '.js-subnav-open',
      close: '.js-subnav-close',
      toggle: '.js-sublist-toggle'
    }
  };
  connector = {
    container: '#connector',
    toggler: '.js-connector-open',
    openClass: 'connector-open'
  };
  hasGallery = false;

  constructor() {
    /* toggle mobile navigation */
    $(document).on('click', [this.trigger.open, this.trigger.close].join(','), (e) => {
      e.preventDefault();
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
      if (this.userProfile) {
        this.userProfile.close();
      }
    });

    // click outside close
    $(document).on('click', (e) => {
      const $target = $(e.target);
      const isHeaderClicked = $target.closest([this.containers.base, this.trigger.open, this.trigger.close].join(',')).length;
      if (!isHeaderClicked) {
        this.close();
      }
    });

    /* sub navigation toggler actions */
    $(document).on('click', this.subnav.trigger.open, (e) => {
      e.preventDefault();
      const target = $(e.currentTarget).data('open');
      $('.topNav-item-content').removeClass('is-open');
      this.openSubNav(target);
    });

    $(document).on('mouseleave', '.topNav-item.has-subnav', (e) => {
      if (DEVICE.isDesktop) {
        if (typeof this.hoverEnterTimeout !== 'undefined') {
          clearTimeout(this.hoverEnterTimeout);
        }
        this.hoverLeaveTimeout = setTimeout(() => {
          $(e.currentTarget).removeClass('is-open');
          $('body').removeClass('navDisplayed');
        }, 300);
      }
    });
    $(document).on('mouseenter', '.topNav-item.has-subnav', (e) => {
      const $currentTarget = $(e.currentTarget);

      if (DEVICE.isDesktop) {
        if (!this.hasGallery && $currentTarget.find('.js-header-map').length) {
          this.buildDomainGallery();
          this.hasGallery = true;
        }

        if (typeof this.hoverLeaveTimeout !== 'undefined') {
          clearTimeout(this.hoverLeaveTimeout);
        }

        this.hoverEnterTimeout = setTimeout(() => {
          $('.topNav-item.has-subnav').removeClass('is-open');
          $currentTarget.addClass('is-open');
          $('body').addClass('navDisplayed');
        }, 200);
      }
    });

    $(document).on('click', this.subnav.trigger.close, (e) => {
      e.preventDefault();
      const target = $(e.currentTarget).parents('.topNav-item-content').first();
      this.closeSubNav(target);
    });

    $(document).on('click', this.subnav.trigger.toggle, (e) => {
      if (!DEVICE.isDesktop) {
        e.preventDefault();
        const target = $(e.currentTarget).data('open');
        this.toggleSubNav(target);
      }
    });

    $(document).on('mouseenter mouseleave', '.topNav-list-link', (e) => {
      if (DEVICE.isDesktop) {
        const target = e.currentTarget;
        const data = $(target).data('domain');
        if (data) {
          this.toggleDomainImage(data, e.type === 'mouseenter');
        }
      }
    });

    if (GLOBAL_SCRIPTS.UNIVERS === 'fba') {
      userProfileModule().then(({UserProfile}) => {
        this.userProfile = new UserProfile();
      });
    } else {
      this.initConnector();
    }

    headerContactModule().then(({HeaderContact}) => {
      this.headerContact = new HeaderContact();
    });

    this.openFirstSubnav();

    if (typeof GMAP_SCRIPTS !== 'undefined') {
      this.initGmap();
    }
  }

  /**
   * Close main navigation
   */
  close() {
    // close all subnavs
    this.closeSubNav('.topNav-item-content.is-open, .topNav-list-item.is-open');

    // reopen first subnav
    this.openFirstSubnav();

    // close main panel
    $('body').removeClass('navDisplayed');
    $('html').removeClass('disableScrollMenuMobile');
    this.isOpen = false;
  }

  /**
   * Open main navigation
   */
  open() {
    $('html').addClass('disableScrollMenuMobile');
    $('body').addClass('navDisplayed');
    this.isOpen = true;
  }

  openSubNav(target) {
    if ($(target).length) {
      $(target).addClass('is-open');
    }
  }

  closeSubNav(target) {
    if ($(target).length) {
      $(target).find('.topNav-list-item.is-open').removeClass('is-open');
      $(target).removeClass('is-open');
    }

    // reopen first subnav
    this.openFirstSubnav();
  }

  /**
   * Toggle subnav (2nd level)
   * @param {string} target
   * @param {boolean} isOpen
   */
  toggleSubNav(target, isOpen) {
    if ($(target).length) {
      $(target).toggleClass('is-open', isOpen);
    }
  }

  openFirstSubnav() {
    this.openSubNav('.topNav-list-item:first');
  }

  /**
   * Show/Hide domain info block in the header
   * @param {object} data - Domain data
   * @param {boolean} isShow - show or hide block
   */
  toggleDomainImage(data, isShow = false) {
    const domain = $('#domNav-' + data.id);
    if (domain.length) {
      $(this.containers.map).toggleClass('u-Hidden--forced', isShow);
      $(this.containers.domain + '[id|=domNav]').addClass('u-Hidden--forced');
      if (isShow) {
        domain.removeClass('u-Hidden--forced');
      }
    }
  }

  /**
   * Header domain preview template
   * @param {string} id - domain code (TH, LG, BF...)
   * @param {string} label - domain name
   * @param {string} image - domain image url
   * @param {string} country - country name full eg: France
   * @param {string} region - country region full eg: Île-de-France
   * @param {string} map - mini-map image url
   * @param {string} tag - new/renovated label
   * @return {string} - template string
   */
  domainImageTpl({id, label, image, country, region, map, tag}) {
    const tagTpl = tag ? `<div class="headerDomain-label productLabel">${tag}</div>` : '';
    const mapTpl = map ? `<img class="headerDomain-map" src="${map}" alt="">` : '';
    const imageTpl = image ? `<img class="headerDomain-img" src="${image}" alt="${label}">` : '';
    const containerClassname = this.containers.domain.replace('.', '');
    return `<div class="${containerClassname} headerDomain u-Hidden--forced" id="domNav-${id}">
              <div class="headerDomain-content">
                <div class="headerDomain-title">${label}${tagTpl}</div>
                <div class="headerDomain-desc">${country}, ${region}</div>
              </div>
              ${imageTpl}
              ${mapTpl}
            </div>`;
  }

  /**
   * Pre-build domains image gallery to switch on hover
   */
  buildDomainGallery() {
    $('.topNav-list-link').each((index, element) => {
      const data = $(element).data('domain');
      if (data) {
        $(this.containers.map).after(this.domainImageTpl(data));
      }
    });
  }

  /**
   * Init connector events
   * @requires Connector
   */
  initConnector() {
    if (typeof Connector !== 'undefined') {
      Connector.init({
        language_code: GLOBAL_SCRIPTS.LANGUAGE_CODE,
        market_code: GLOBAL_SCRIPTS.MARKET_CODE,
        univers_id: GLOBAL_SCRIPTS.UNIVERS_ID,
        baseUrl: GLOBAL_SCRIPTS.HOST,
        onToggle: () => {
          if (typeof priceTooltip !== 'undefined') {
            /* On repositionne la tooltip "Mon compte" le plus tôt possible. */
            priceTooltip.refreshActivePopinPosition();
          }
        },
        onOpen: () => {
          const bookingDetailStorage = localStorage.getItem('bookingDetail');
          const lastBookingInThePast = bookingDetailStorage !== null ? JSON.parse(bookingDetailStorage).infosBooking.inThePast : null;
          const userStorage = localStorage.getItem('users');
          Tracking.dataLayerPush({
            popinName: 'CP Connector layer',
            popinContainsFormInfos: false,
            popin_shrturl: '/' + GLOBAL_SCRIPTS.MARKET_LANGUAGE + '/cpconnector',
            lastBookingStatus: lastBookingInThePast === true ? 'old' : (lastBookingInThePast === false ? 'new' : ''),
            userId: userStorage !== null ? JSON.parse(userStorage).user.emailMd5 : '',
            event: 'popinDisplay'
          });
        }
      });
    }

    /* Connector toggler actions */
    $(document).on('click', this.connector.toggler, (e) => {
      e.preventDefault();
      const { options } = Connector;

      if (typeof Connector === 'undefined' || !$(this.connector.container).length || !options) return;
      const { onOpen, onClose } = options;

      if (onOpen !== undefined) {
        Connector.isOpen() && onClose !== undefined ? Connector.close() : Connector.open();
      }
    });

    // Close connector when clicked outside
    $(document).on('click', (e) => {
      const { container, toggler } = this.connector;

      if (typeof Connector === 'undefined' || !$(container).length) return;

      const isConnectorClicked = $(e.target).closest(`${container}, ${toggler}`).length;

      if (!isConnectorClicked) {
        Connector.close();
      }
    });
  }

  /**
   * Global GMap management
   */
  initGmap() {
    this.gmapFancyView = new FancyboxView({
      selector: '.js-open-map',
      fancyType: 'custom',
      options: {
        infobar: false,
        toolbar: false,
        buttons: ['close', 'fullScreen'],
        touch: {
          vertical: false,
          momentum: true
        },
        modal: true
      }
    });
    gmapModule().then(({MapController}) => {
      this.gmap = new MapController();
    });
  }
};